import { types } from '../actions/languages';

const initialState = {
  response: null
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_LANGUAGES_FULFILLED:
      return {
        ...state,
        response: action.payload?.data
      };
    default:
      return state;
  }
}
